module.exports = __webpack_public_path__ + "fonts/Poppins-Bold.cdb29a5.ttf";